var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07413 17C4.33867 14.5843 0.528365 10.3869 0.0467906 6.39714C-0.354794 3.07049 1.87216 0.418454 5.05255 0.0543594C9.031 -0.401185 11.9471 2.05934 11.9993 5.45046C12.0344 7.7242 10.719 10.003 9.64967 11.7932C8.51091 13.7 7.19001 15.4558 6.07413 17ZM5.46118 9.04786C6.84216 9.20586 8.70164 8.55804 9.3432 7.05982C10.578 4.17622 7.83585 2.09068 5.25687 2.51574C1.43042 3.14642 1.52941 8.59809 5.46118 9.04786Z",
    fill: "#3A3A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListMap);
export default __webpack_public_path__ + "static/media/icon-list-map.b307a1e77d2029a388e641c889c1d7f7.svg";
export { ForwardRef as ReactComponent };